module.exports = __webpack_public_path__ + "img/about-bg-pattern.8531f7ed.png";